import NewsCategory from "./newsCategoryEntity";

export default class NewsItem {
    public id: string;
    public title: string;
    public publicationDate: Date;
    public body: string;
    public newsImage: string;
    public categories: NewsCategory[];
  
    constructor() {
      this.id = "";
      this.title = "";
      this.body = "";
      this.newsImage = "";

      this.categories = [];
    }
  }


// WEBPACK FOOTER //
// ./src/api/newsItemEntity.ts